import { isEmpty, uniqBy } from 'lodash/fp';
import { Card, SpacingMediumBottom } from '@mews-commander/ui';
import { Reservation } from '@mews-commander/data-access';
import ReservationsOverviewContent from './ReservationsOverviewContent';

interface Props {
    reservations: Reservation[];
}
const ReservationsOverview: React.FC<Props> = ({ reservations }) => {
    // @ts-expect-error $TSFixMeError: Type '{ toString: unknown; charAt: unknown; charCodeAt: unknown; concat: unknown; indexOf: unknown; lastIndexOf: unknown...
    const serviceReservations: Reservation[] = uniqBy('serviceId')(reservations);

    return isEmpty(serviceReservations) ? null : (
        <>
            {serviceReservations.map(({ serviceId }) => (
                <Card padding="0" key={serviceId}>
                    {/* @ts-expect-error $TSFixMeError: JSX element type 'ReservationsOverviewContent' does not have any construct or call signatures. */}
                    <ReservationsOverviewContent serviceId={serviceId} />
                    <SpacingMediumBottom />
                </Card>
            ))}
        </>
    );
};

export default ReservationsOverview;
